import type { ComponentPropsWithoutRef } from "react";
import type { Control } from "react-hook-form";
import { t } from "ttag";

import { Checkbox, Form } from "@/shared/ui";

interface FieldValue {
  authorization?: boolean;
}

type CreditCardAuthorizationControl<T> = T extends FieldValue
  ? Control<T, "authorization">
  : never;

type CreditCardAuthorizationFieldProps<T extends FieldValue> =
  ComponentPropsWithoutRef<typeof Form.Item> & {
    control: CreditCardAuthorizationControl<T>;
  };
export const CreditCardAuthorizationField = <T extends FieldValue>({
  control,
  ...props
}: CreditCardAuthorizationFieldProps<T>) => {
  return (
    <Form.Field
      control={control}
      name="authorization"
      render={({ field: { value, onChange, ...rest } }) => (
        <Form.Item id="credit-card-authorization" {...props}>
          <Form.Control>
            <Checkbox.Item {...rest} checked={value} onCheckedChange={onChange}>
              <Checkbox.Label>
                {t`I authorize the use of this credit card for my subscription charges`}
              </Checkbox.Label>
            </Checkbox.Item>
          </Form.Control>

          <Form.Message compact={false} />
        </Form.Item>
      )}
    />
  );
};
